import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1385.155 -4200.39)">
      <path
        d="M255.6,38.14a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4163)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M268.576,45.646A15.03,15.03,0,0,0,255.6,38.14v15L248.1,66.121a14.982,14.982,0,0,0,20.475-20.475"
        transform="translate(-1625 4163)"
        fill={color}
      />
    </g>
  </svg>
);
